import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';

export const useProviderServices = () => {
  return useSelector(Global.selectSellerServices);
};
